import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import { z } from 'zod/v4';

export const selectProposalExtensionSchema = createSelectSchema(schema.proposalExtensions);

export const insertProposalExtensionSchema = createInsertSchema(schema.proposalExtensions, {
  ownerId: z.string().uuid(),
  proposalId: z.string().uuid().optional().nullable(),
  markupPercent: z.string().optional().nullable(),
  overheadPercent: z.string().optional().nullable(),
  marginPercent: z.string().optional().nullable(),
  contractId: z.string().max(255),
  businessUnitId: z.string().uuid().optional().nullable(),
  projectTypeId: z.string().uuid().optional().nullable(),
}).omit({
  organizationId: true,
}).extend({
  estimatorIds: z.array(z.string().uuid()).optional(),
  projectTypeIds: z.array(z.string().uuid()).optional(),
});

export const updateProposalExtensionSchema = insertProposalExtensionSchema.partial().extend({
  id: z.string().uuid(),
});
